import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';

import Home from './pages/Home';
import NavBar from './components/NavBar';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


function App() {

  return ( 
    <Router>
      <div>
        <NavBar/>
      </div>

      <Routes>
        <Route path='/' element={<Home />} />
      </Routes>
    </Router>
    
  );
}

export default App;
